export { default as LastContents } from './LastContents';
